// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"53f1fe8a","569":"2b320e34"}[chunkId] + ".chunk.js";
};